import { Controller } from "@hotwired/stimulus";
import React from "react";
import { createRoot } from "react-dom/client";

// Import all available React components
import App from "../react/App";
import ReactIsland from "../react/ReactIsland";
import Carousel from "../react/Carousel";
import CarouselSection from "../react/CarouselSection";
import Countdown from "../react/Countdown";
import MinimalHomepage from "../react/MinimalHomepage";
import FullHomepage from "../react/FullHomepage";
import SolutionClinicalAffairs from "../react/SolutionClinicalAffairs";
import SolutionRegulatory from "../react/SolutionRegulatory";
import hp_v_1_1_3 from "../react/hp_v_1_1_3";
import ClinicalInvestigation from "../react/ClinicalInvestigation";
import cq_service_v1 from "../react/cq_service_v1";


// Component registry - add new components here
const COMPONENT_REGISTRY = {
  'App': App,
  'ReactIsland': ReactIsland,
  'Carousel': Carousel,
  'CarouselSection': CarouselSection,
  'Countdown': Countdown,
  'MinimalHomepage': MinimalHomepage,
  'FullHomepage': FullHomepage,
  'SolutionClinicalAffairs': SolutionClinicalAffairs,
  'SolutionRegulatory': SolutionRegulatory,
  'hp_v_1_1_3': hp_v_1_1_3,
  'ClinicalInvestigation': ClinicalInvestigation,
  'cq_service_v1': cq_service_v1,
  // Add more components as needed
};

export default class extends Controller {
  static targets = ["mount"];

  connect() {
    const el = this.mountTarget;
    const props = JSON.parse(el.getAttribute("data-props") || "{}");
    const componentName = el.getAttribute("data-component") || "App";
    
    // Get the component from registry
    const Component = COMPONENT_REGISTRY[componentName];
    
    if (!Component) {
      console.error(`React component '${componentName}' not found in registry`);
      this.showError(`Component '${componentName}' not found`);
      return;
    }

    try {
      this.root = createRoot(el);
      this.root.render(<Component {...props} />);
    } catch (error) {
      console.error(`Error rendering React component '${componentName}':`, error);
      this.showError(`Failed to render ${componentName}`);
    }
  }

  disconnect() {
    if (this.root) {
      this.root.unmount();
    }
    this.root = null;
  }

  showError(message) {
    const el = this.hasMountTarget ? this.mountTarget : this.element;
    el.replaceChildren();
    const box = document.createElement("div");
    box.className = "bg-red-50 border border-red-200 rounded-lg p-6 text-center";
    box.setAttribute("role", "alert");
    box.textContent = message;
    el.appendChild(box);
  }
}
